import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"

import SEO from "../components/seo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"


export default ({ data, location, pageContext }) => (
    <Layout>
        <SEO
            pagetitle=" ブログ"
            pagedesc="Tylerのブログです"
            pagepath={location.pathname}
        />
        <section className="content bloglist container-bkg">
            <div className="container">
                <h1 className="bar font-Allerta-Stencil">Blog List</h1>
                <div className="posts">
                    {data.allContentfulBlogPost.edges.map(({ node }) => (

                        <article className="post" key={node.id}>
                            <Link to={`/blog/post/${node.slug}/`}>
                                <figure>
                                    <Img
                                        fluid={node.eyecatch.fluid}
                                        alt={node.eyecatch.description}
                                        style={{ height: "100%" , width: "100%" }}
                                    />
                                </figure>
                                <h3>{node.title}</h3>
                                <p className="first-content">{node.firstdec}...</p>
                                <div className="post-footer">
                                <div className="categories">
                                  {node.category.map(cat => (
                                    <span className={`category ${cat.categorySlug}`} key={cat.key}>
                                      <Link to={`/cat/${cat.categorySlug}/`}>{cat.category}</Link>
                                    </span>
                                  ))}
                                    </div>
                                  <span className="pub-date">{node.publishDateJP}</span>
                                </div>
                            </Link>
                        </article>
                    )) }
                </div>

                <ul className="pagenation">
                    {!pageContext.isFirst && (
                    <li className="prev">
                        <Link to={
                            pageContext.currentPage === 2
                                ? `/blog/`
                                : `/blog/${pageContext.currentPage - 1}/`
                        }
                        rel="prev" className="newmo-sm"
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                            <span>前のページ</span>
                        </Link>
                    </li>
                    )}
                    <li className="next">
                        {!pageContext.isLast && (
                            <Link to={`/blog/${pageContext.currentPage + 1}/`} rel="next" className="newmo-sm">
                                <span>次のページ</span>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </Link>
                        )}
                    </li>
                </ul>

            </div>
        </section>
    </Layout>
)


export const query = graphql`
    query ($skip: Int!, $limit:Int! ) {
        allContentfulBlogPost(
            sort: {fields: publishDate, order: DESC}
            skip: $skip
            limit: $limit
            ) {
            edges {
                node {
                    title
                    id
                    firstdec
                    slug
                    category {
                      category
                      categorySlug
                      id
                    }
                    publishDateJP:publishDate(formatString: "YYYY年MM月DD日")
                          eyecatch {
                        fluid(maxWidth: 356) {
                            ...GatsbyContentfulFluid_withWebp
                        }
                        description
                    }
                }
            }
        }
    }
`